import { formatMenuLabel } from "./helper.js";

const BLOCK_SELECTOR = "[data-id]";
const TOPIC_HEADING = "h1";
const SUBSECTION_HEADING = "h2";

const readLabelFromDataId = (dataId) => {
  const separatorIndex = dataId.indexOf("-");
  if (separatorIndex === -1) {
    return formatMenuLabel(dataId);
  }
  const labelPart = dataId.slice(separatorIndex + 1);
  return formatMenuLabel(labelPart);
};

const readLabel = (element, headingTag) => {
  const heading = element.querySelector(headingTag);
  if (heading) {
    return heading.textContent.trim();
  }
  return readLabelFromDataId(element.dataset.id);
};

const createTopic = (blockElement) => {
  const topic = {
    dataId: blockElement.dataset.id,
    label: readLabel(blockElement, TOPIC_HEADING),
    children: [],
  };
  return topic;
};

const createSubsection = (blockElement) => {
  const subsection = {
    dataId: blockElement.dataset.id,
    label: readLabel(blockElement, SUBSECTION_HEADING),
  };
  return subsection;
};

export const parseTopics = (sectionName, sectionHtml) => {
  const parsedDocument = new DOMParser().parseFromString(
    sectionHtml,
    "text/html"
  );
  const blockElements = parsedDocument.querySelectorAll(BLOCK_SELECTOR);
  const topicPrefix = `${sectionName}-`;

  const topics = [];
  blockElements.forEach((blockElement) => {
    const isTopic = blockElement.dataset.id.startsWith(topicPrefix);
    if (isTopic) {
      topics.push(createTopic(blockElement));
      return;
    }

    const currentTopic = topics[topics.length - 1];
    if (currentTopic) {
      currentTopic.children.push(createSubsection(blockElement));
    }
  });

  return topics;
};
